'use strict';

var MeshRendererDirective = function MeshRendererDirective () {

  function link (scope, el, attrs, ctrl) {
    //detect when the scene changes
    scope.$watch('scene', ctrl._handleSceneChange.bind(ctrl), true);
    ctrl.init();
  };

  return {
    controller: 'MeshRendererController',
    controllerAs: 'meshRendererCtrl',
    link: link,
    templateUrl: 'saturn/meshRenderer/meshRenderer.tpl.html',
    scope : {
      scene : '='
    }
  };
}

module.exports = MeshRendererDirective;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/meshRenderer/src/MeshRendererDirective.js